import type { HelpFile } from '../../types/help'
import { LayoutCanvasTestIds } from '../../../testids/LayoutCanvasTestIds'

export const layoutCanvasHelp: HelpFile = {
  docPage: '/docs/schema/form-layouts',
  texts: {
    [LayoutCanvasTestIds.canvasAddSectionBtn]:
      'Add a new section to the layout — sections group related fields together visually.',
    [LayoutCanvasTestIds.canvasAddSectionMoreBtn]:
      'Add another section below the existing ones.',
    [LayoutCanvasTestIds.canvasEmptyTitle]:
      'The layout is empty — add a section to start arranging fields.',
  },
}
